import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mark',
  standalone: false,
})
export class MarkPipe implements PipeTransform {
  transform(value: string, query: string): string {
    if (!query) {
      return value;
    }
    const queryEscaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(queryEscaped, 'gi');
    const match = value.match(regex);

    if (!match) {
      return value;
    }

    return value.replace(regex, `<mark>${match[0]}</mark>`);
  }
}
